import { render, staticRenderFns } from "./jala-farm.vue?vue&type=template&id=851d49e2&"
import script from "./jala-farm.vue?vue&type=script&lang=js&"
export * from "./jala-farm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports